
import React, { createContext, useContext, useState } from "react";

type Theme = 'light' | 'dark';

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProviderContext = createContext<ThemeContextType | null>(null);

export function ThemeProvider({
  children,
  ...props
}: ThemeProviderProps) {
  // Always use light theme as requested
  const [theme] = useState<Theme>('light');
  
  // Apply light mode to document root
  React.useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("dark");
    root.classList.add("light");
  }, []);

  const value = {
    theme,
    setTheme: () => {}, // Empty function since we're not using dark mode anymore
  };

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);
  
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  
  return context;
};
